// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 0;
  background-color: #ffffff;
  min-height: 100vh;
}
:host-context(body.theme-dark) .notifications-container {
  background-color: #0f0f0f;
  color: #ffffff;
}

.notifications-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
:host-context(body.theme-dark) .notifications-header {
  background-color: #0f0f0f;
  border-bottom-color: rgba(255, 255, 255, 0.1);
}
@media (max-width: 768px) {
  .notifications-header {
    padding: 16px 24px;
  }
}

.notifications-title {
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  color: #030303;
  letter-spacing: 0.5px;
}
:host-context(body.theme-dark) .notifications-title {
  color: #ffffff;
}
@media (max-width: 768px) {
  .notifications-title {
    font-size: 20px;
  }
}

.mark-all-read-btn {
  color: #065fd4;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  padding: 8px 16px;
  border-radius: 18px;
  transition: background-color 0.2s;
}
.mark-all-read-btn:hover {
  background-color: rgba(6, 95, 212, 0.1);
}
@media (max-width: 768px) {
  .mark-all-read-btn {
    font-size: 14px;
    padding: 8px 16px;
  }
}

.skeleton-notification-item {
  pointer-events: none;
  cursor: default;
}
.skeleton-notification-item:hover {
  background-color: transparent !important;
}

.skeleton-section-title {
  height: 20px;
  width: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin: 16px 24px 8px;
  animation: skeleton-wave 1.5s ease-in-out infinite;
}
:host-context(body.theme-dark) .skeleton-section-title {
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
}

.skeleton-avatar {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-wave 1.5s ease-in-out infinite;
}
:host-context(body.theme-dark) .skeleton-avatar {
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
}

.skeleton-message-line {
  height: 14px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin-bottom: 6px;
  animation: skeleton-wave 1.5s ease-in-out infinite;
}
:host-context(body.theme-dark) .skeleton-message-line {
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
}
.skeleton-message-line.skeleton-message-line-short {
  width: 60%;
}

.skeleton-time-line {
  height: 12px;
  width: 80px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin-top: 4px;
  animation: skeleton-wave 1.5s ease-in-out infinite;
}
:host-context(body.theme-dark) .skeleton-time-line {
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
}

.skeleton-thumbnail {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: skeleton-wave 1.5s ease-in-out infinite;
}
:host-context(body.theme-dark) .skeleton-thumbnail {
  background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);
  background-size: 200% 100%;
}

@keyframes skeleton-wave {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  min-height: 400px;
  text-align: center;
}
.empty-state .empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}
.empty-state h2 {
  font-size: 20px;
  font-weight: 500;
  margin: 0 0 8px 0;
  color: #030303;
}
:host-context(body.theme-dark) .empty-state h2 {
  color: #ffffff;
}
.empty-state p {
  font-size: 14px;
  color: #606060;
  margin: 0;
}
:host-context(body.theme-dark) .empty-state p {
  color: #aaaaaa;
}

.notifications-list {
  padding: 0;
}

.notification-section {
  margin-bottom: 32px;
}
@media (max-width: 768px) {
  .notification-section {
    margin-bottom: 32px;
  }
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #030303;
  padding: 16px 24px 8px;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
:host-context(body.theme-dark) .section-title {
  color: #ffffff;
}
@media (max-width: 768px) {
  .section-title {
    font-size: 16px;
    padding: 16px 24px 8px;
  }
}

/* Strong dark-mode pass for notifications page */
:host-context(body.theme-dark) .notifications-container {
  background: #0a0c10 !important;
  color: #e5e7eb !important;
}
:host-context(body.theme-dark) .notifications-header {
  background: #111827 !important;
  border-bottom-color: rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .notifications-title,
:host-context(body.theme-dark) .section-title,
:host-context(body.theme-dark) .notification-message,
:host-context(body.theme-dark) .notification-content-title {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .notification-time,
:host-context(body.theme-dark) .notification-date,
:host-context(body.theme-dark) .empty-state p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .notification-item {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.22) !important;
}
:host-context(body.theme-dark) .notification-item:hover {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .notification-item.unread {
  background: rgba(59, 130, 246, 0.14) !important;
}
:host-context(body.theme-dark) .notification-item.unread::before {
  background-color: #60a5fa !important;
}
:host-context(body.theme-dark) .notification-item.unread::after {
  background-color: #60a5fa !important;
}
:host-context(body.theme-dark) .notification-item.unread .notification-message {
  font-weight: 600 !important;
  color: #f1f5f9 !important;
}
:host-context(body.theme-dark) .notification-item:not(.unread) .notification-message {
  font-weight: 400 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .notification-calendar-btn,
:host-context(body.theme-dark) .mark-all-read-btn {
  background: rgba(94, 161, 216, 0.15) !important;
  color: #93c5fd !important;
  border-color: rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .notification-calendar-btn:hover,
:host-context(body.theme-dark) .mark-all-read-btn:hover {
  background: rgba(94, 161, 216, 0.24) !important;
}
:host-context(body.theme-dark) .notifications-container p,
:host-context(body.theme-dark) .notifications-container span,
:host-context(body.theme-dark) .notifications-container label,
:host-context(body.theme-dark) .notifications-container small,
:host-context(body.theme-dark) .notifications-container li {
  color: #cbd5e1 !important;
}

.notification-items {
  display: flex;
  flex-direction: column;
}

.notification-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 24px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  position: relative;
  gap: 12px;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}
.notification-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
:host-context(body.theme-dark) .notification-item:hover {
  background-color: rgba(255, 255, 255, 0.06);
}
@media (max-width: 768px) {
  .notification-item {
    padding: 12px 24px;
    gap: 12px;
  }
}
.notification-item.unread {
  background-color: rgba(6, 95, 212, 0.07);
}
.notification-item.unread::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background-color: #065fd4;
  border-radius: 0 2px 2px 0;
}
.notification-item.unread::after {
  content: "";
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #065fd4;
  flex-shrink: 0;
}
.notification-item.unread .notification-message {
  font-weight: 600 !important;
  color: #111 !important;
}
:host-context(body.theme-dark) .notification-item.unread {
  background-color: rgba(59, 130, 246, 0.14);
}
:host-context(body.theme-dark) .notification-item.unread::before {
  background-color: #60a5fa;
}
:host-context(body.theme-dark) .notification-item.unread::after {
  background-color: #60a5fa;
}
:host-context(body.theme-dark) .notification-item.unread .notification-message {
  color: #f1f5f9 !important;
}

.notification-item.notification-item-disabled {
  cursor: not-allowed;
  opacity: 0.65;
}
.notification-item.notification-item-disabled:hover {
  background-color: transparent;
}

.notification-item:not(.skeleton-notification-item) .notification-avatar {
  cursor: pointer;
}

.notification-avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  align-self: flex-start;
}
@media (max-width: 768px) {
  .notification-avatar {
    width: 40px;
    height: 40px;
    align-self: flex-start;
  }
}
.notification-avatar .avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.notification-avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 500;
  font-size: 16px;
  text-transform: uppercase;
}
@media (max-width: 768px) {
  .notification-avatar .avatar-placeholder {
    font-size: 16px;
  }
}

.notification-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.notification-content .notification-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.notification-content .notification-message {
  display: block;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #333;
  word-wrap: break-word;
  /* Preserve API newlines: title / body / meta on separate lines */
  white-space: pre-line;
}
:host-context(body.theme-dark) .notification-content .notification-message {
  color: #ffffff;
}
@media (max-width: 768px) {
  .notification-content .notification-message {
    font-size: 14px;
  }
}
.notification-content .notification-message a {
  color: #065fd4;
  text-decoration: none;
}
.notification-content .notification-message a:hover {
  text-decoration: underline;
}
.notification-content .notification-time {
  font-size: 12px;
  color: #606060;
  white-space: nowrap;
  flex-shrink: 0;
}
:host-context(body.theme-dark) .notification-content .notification-time {
  color: #aaaaaa;
}
@media (max-width: 768px) {
  .notification-content .notification-time {
    font-size: 12px;
  }
}
.notification-content .notification-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}
@media (min-width: 769px) {
  .notification-content .notification-title-row {
    flex-direction: column;
    align-items: flex-start;
  }
}
.notification-content .notification-content-title {
  font-size: 13px;
  color: #606060;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  flex: 1;
  min-width: 0;
}
:host-context(body.theme-dark) .notification-content .notification-content-title {
  color: #aaaaaa;
}
@media (max-width: 768px) {
  .notification-content .notification-content-title {
    font-size: 13px;
  }
}

.notification-thumbnail {
  flex-shrink: 0;
  width: 80px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #f9f9f9;
  position: relative;
}
:host-context(body.theme-dark) .notification-thumbnail {
  background-color: #1f1f1f;
}
.notification-thumbnail .thumbnail-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.notification-thumbnail--clickable {
  cursor: pointer;
}

@media (max-width: 768px) {
  .notifications-container {
    padding: 0;
  }
}
@media (min-width: 1200px) {
  .notifications-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  .notification-item {
    padding: 14px 32px;
  }
}
.notification-item:focus {
  outline: 2px solid #065fd4;
  outline-offset: -2px;
}
.notification-item:focus:not(:focus-visible) {
  outline: none;
}

* {
  transition: background-color 0.15s ease, color 0.15s ease;
}

.notification-calendar-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.notification-calendar-btn {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #065fd4;
  background: #fff;
  color: #065fd4;
  cursor: pointer;
}
.notification-calendar-btn:hover {
  background: rgba(6, 95, 212, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/notifications/notifications.component.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;AADF;AAIE;EACE,yBAAA;EACA,cAAA;AAFJ;;AAOA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;EACA,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,yCAAA;AAJF;AAME;EACE,yBAAA;EACA,6CAAA;AAJJ;AAOE;EAjBF;IAkBI,kBAAA;EAJF;AACF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,qBAAA;AAJF;AAME;EACE,cAAA;AAJJ;AAOE;EAXF;IAYI,eAAA;EAJF;AACF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iCAAA;AAJF;AAME;EACE,uCAAA;AAJJ;AAOE;EAbF;IAcI,eAAA;IACA,iBAAA;EAJF;AACF;;AAQA;EACE,oBAAA;EACA,eAAA;AALF;AAOE;EACE,wCAAA;AALJ;;AASA;EACE,YAAA;EACA,WAAA;EACA,yEAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EACA,kDAAA;AANF;AAQE;EACE,yEAAA;EACA,0BAAA;AANJ;;AAUA;EACE,yEAAA;EACA,0BAAA;EACA,kDAAA;AAPF;AASE;EACE,yEAAA;EACA,0BAAA;AAPJ;;AAWA;EACE,YAAA;EACA,yEAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kDAAA;AARF;AAUE;EACE,yEAAA;EACA,0BAAA;AARJ;AAWE;EACE,UAAA;AATJ;;AAaA;EACE,YAAA;EACA,WAAA;EACA,yEAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kDAAA;AAVF;AAYE;EACE,yEAAA;EACA,0BAAA;AAVJ;;AAcA;EACE,yEAAA;EACA,0BAAA;EACA,kDAAA;AAXF;AAaE;EACE,yEAAA;EACA,0BAAA;AAXJ;;AAeA;EACE;IACE,4BAAA;EAZF;EAcA;IACE,2BAAA;EAZF;AACF;AAgBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAdF;AAgBE;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AAdJ;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAfJ;AAiBI;EACE,cAAA;AAfN;AAmBE;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAjBJ;AAmBI;EACE,cAAA;AAjBN;;AAuBA;EACE,UAAA;AApBF;;AAuBA;EACE,mBAAA;AApBF;AAsBE;EAHF;IAII,mBAAA;EAnBF;AACF;;AAsBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,qBAAA;AAnBF;AAqBE;EACE,cAAA;AAnBJ;AAsBE;EAbF;IAcI,eAAA;IACA,sBAAA;EAnBF;AACF;;AAsBA,iDAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AApBJ;AAuBE;EACE,8BAAA;EACA,yDAAA;AArBJ;AAwBE;;;;EAIE,yBAAA;AAtBJ;AAyBE;;;EAGE,yBAAA;AAvBJ;AA0BE;EACE,8BAAA;EACA,kDAAA;AAxBJ;AA2BE;EACE,8BAAA;AAzBJ;AA6BE;EACE,+CAAA;AA3BJ;AA6BI;EACE,oCAAA;AA3BN;AA8BI;EACE,oCAAA;AA5BN;AA+BI;EACE,2BAAA;EACA,yBAAA;AA7BN;AAmCI;EACE,2BAAA;EACA,yBAAA;AAjCN;AAqCE;;EAEE,+CAAA;EACA,yBAAA;EACA,iDAAA;AAnCJ;AAsCE;;EAEE,+CAAA;AApCJ;AAuCE;;;;;EAKE,yBAAA;AArCJ;;AAyCA;EACE,aAAA;EACA,sBAAA;AAtCF;;AA0CA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,uCAAA;EACA,kBAAA;EACA,SAAA;EACA,0BAAA;EACA,wCAAA;AAvCF;AAyCE;EACE,qCAAA;AAvCJ;AA2CI;EACE,2CAAA;AAzCN;AA6CE;EArBF;IAsBI,kBAAA;IACA,SAAA;EA1CF;AACF;AA6CE;EAEE,wCAAA;AA5CJ;AA+CI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,0BAAA;AA7CN;AAiDI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AA/CN;AAmDI;EACE,2BAAA;EACA,sBAAA;AAjDN;AAqDI;EACE,0CAAA;AAnDN;AAqDM;EACE,yBAAA;AAnDR;AAsDM;EACE,yBAAA;AApDR;AAuDM;EACE,yBAAA;AArDR;;AA2DA;EACE,mBAAA;EACA,aAAA;AAxDF;AA0DE;EACE,6BAAA;AAxDJ;;AA6DA;EACE,eAAA;AA1DF;;AA6DA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AA1DF;AA4DE;EATF;IAUI,WAAA;IACA,YAAA;IACA,sBAAA;EAzDF;AACF;AA2DE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AAzDJ;AA4DE;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA1DJ;AA4DI;EAZF;IAaI,eAAA;EAzDJ;AACF;;AA8DA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA3DF;AA6DE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3DJ;AA8DE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,iEAAA;EACA,qBAAA;AA5DJ;AA8DI;EACE,cAAA;AA5DN;AA+DI;EAdF;IAeI,eAAA;EA5DJ;AACF;AA+DI;EACE,cAAA;EACA,qBAAA;AA7DN;AA+DM;EACE,0BAAA;AA7DR;AAkEE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AAhEJ;AAkEI;EACE,cAAA;AAhEN;AAmEI;EAVF;IAWI,eAAA;EAhEJ;AACF;AAmEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAjEJ;AAmEI;EANF;IAQI,sBAAA;IACA,uBAAA;EAjEJ;AACF;AAoEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,OAAA;EACA,YAAA;AAlEJ;AAoEI;EACE,cAAA;AAlEN;AAqEI;EAjBF;IAkBI,eAAA;EAlEJ;AACF;;AAuEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AApEF;AAsEE;EACE,yBAAA;AApEJ;AAuEE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AArEJ;;AAyEA;EACE,eAAA;AAtEF;;AA0EA;EACE;IACE,UAAA;EAvEF;AACF;AA2EA;EACE;IACE,iBAAA;IACA,cAAA;EAzEF;EA4EA;IACE,kBAAA;EA1EF;AACF;AA+EE;EACE,0BAAA;EACA,oBAAA;AA7EJ;AAgFE;EACE,aAAA;AA9EJ;;AAmFA;EACE,yDAAA;AAhFF;;AAmFA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAhFF;;AAmFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAhFF;AAkFE;EACE,kCAAA;AAhFJ","sourcesContent":["// Notifications component styles\n\n.notifications-container {\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0;\n  background-color: #ffffff;\n  min-height: 100vh;\n\n  // Dark mode support (optional)\n  :host-context(body.theme-dark) & {\n    background-color: #0f0f0f;\n    color: #ffffff;\n  }\n}\n\n// Header\n.notifications-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 24px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  background-color: #ffffff;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n  :host-context(body.theme-dark) & {\n    background-color: #0f0f0f;\n    border-bottom-color: rgba(255, 255, 255, 0.1);\n  }\n\n  @media (max-width: 768px) {\n    padding: 16px 24px;\n  }\n}\n\n.notifications-title {\n  font-size: 20px;\n  font-weight: 500;\n  margin: 0;\n  color: #030303;\n  letter-spacing: 0.5px;\n\n  :host-context(body.theme-dark) & {\n    color: #ffffff;\n  }\n\n  @media (max-width: 768px) {\n    font-size: 20px;\n  }\n}\n\n.mark-all-read-btn {\n  color: #065fd4;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: none;\n  padding: 8px 16px;\n  border-radius: 18px;\n  transition: background-color 0.2s;\n\n  &:hover {\n    background-color: rgba(6, 95, 212, 0.1);\n  }\n\n  @media (max-width: 768px) {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n}\n\n// Skeleton Loader Styles\n.skeleton-notification-item {\n  pointer-events: none;\n  cursor: default;\n\n  &:hover {\n    background-color: transparent !important;\n  }\n}\n\n.skeleton-section-title {\n  height: 20px;\n  width: 80px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  border-radius: 4px;\n  margin: 16px 24px 8px;\n  animation: skeleton-wave 1.5s ease-in-out infinite;\n\n  :host-context(body.theme-dark) & {\n    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);\n    background-size: 200% 100%;\n  }\n}\n\n.skeleton-avatar {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-wave 1.5s ease-in-out infinite;\n\n  :host-context(body.theme-dark) & {\n    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);\n    background-size: 200% 100%;\n  }\n}\n\n.skeleton-message-line {\n  height: 14px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  border-radius: 4px;\n  margin-bottom: 6px;\n  animation: skeleton-wave 1.5s ease-in-out infinite;\n\n  :host-context(body.theme-dark) & {\n    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);\n    background-size: 200% 100%;\n  }\n\n  &.skeleton-message-line-short {\n    width: 60%;\n  }\n}\n\n.skeleton-time-line {\n  height: 12px;\n  width: 80px;\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  border-radius: 4px;\n  margin-top: 4px;\n  animation: skeleton-wave 1.5s ease-in-out infinite;\n\n  :host-context(body.theme-dark) & {\n    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);\n    background-size: 200% 100%;\n  }\n}\n\n.skeleton-thumbnail {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: skeleton-wave 1.5s ease-in-out infinite;\n\n  :host-context(body.theme-dark) & {\n    background: linear-gradient(90deg, #2a2a2a 25%, #3a3a3a 50%, #2a2a2a 75%);\n    background-size: 200% 100%;\n  }\n}\n\n@keyframes skeleton-wave {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n// Empty State\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 20px;\n  min-height: 400px;\n  text-align: center;\n\n  .empty-icon {\n    font-size: 64px;\n    margin-bottom: 16px;\n    opacity: 0.5;\n  }\n\n  h2 {\n    font-size: 20px;\n    font-weight: 500;\n    margin: 0 0 8px 0;\n    color: #030303;\n\n    :host-context(body.theme-dark) & {\n      color: #ffffff;\n    }\n  }\n\n  p {\n    font-size: 14px;\n    color: #606060;\n    margin: 0;\n\n    :host-context(body.theme-dark) & {\n      color: #aaaaaa;\n    }\n  }\n}\n\n// Notifications List\n.notifications-list {\n  padding: 0;\n}\n\n.notification-section {\n  margin-bottom: 32px;\n\n  @media (max-width: 768px) {\n    margin-bottom: 32px;\n  }\n}\n\n.section-title {\n  font-size: 16px;\n  font-weight: 500;\n  color: #030303;\n  padding: 16px 24px 8px;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n\n  :host-context(body.theme-dark) & {\n    color: #ffffff;\n  }\n\n  @media (max-width: 768px) {\n    font-size: 16px;\n    padding: 16px 24px 8px;\n  }\n}\n\n/* Strong dark-mode pass for notifications page */\n:host-context(body.theme-dark) {\n  .notifications-container {\n    background: #0a0c10 !important;\n    color: #e5e7eb !important;\n  }\n\n  .notifications-header {\n    background: #111827 !important;\n    border-bottom-color: rgba(148, 163, 184, 0.25) !important;\n  }\n\n  .notifications-title,\n  .section-title,\n  .notification-message,\n  .notification-content-title {\n    color: #f8fafc !important;\n  }\n\n  .notification-time,\n  .notification-date,\n  .empty-state p {\n    color: #cbd5e1 !important;\n  }\n\n  .notification-item {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.22) !important;\n  }\n\n  .notification-item:hover {\n    background: #1f2937 !important;\n  }\n\n  // Dark-mode unread: stronger blue wash + dot override\n  .notification-item.unread {\n    background: rgba(59, 130, 246, 0.14) !important;\n\n    &::before {\n      background-color: #60a5fa !important;\n    }\n\n    &::after {\n      background-color: #60a5fa !important;\n    }\n\n    .notification-message {\n      font-weight: 600 !important;\n      color: #f1f5f9 !important;\n    }\n  }\n\n  // Ensure read items have normal text weight in dark mode\n  .notification-item:not(.unread) {\n    .notification-message {\n      font-weight: 400 !important;\n      color: #e2e8f0 !important;\n    }\n  }\n\n  .notification-calendar-btn,\n  .mark-all-read-btn {\n    background: rgba(94, 161, 216, 0.15) !important;\n    color: #93c5fd !important;\n    border-color: rgba(94, 161, 216, 0.35) !important;\n  }\n\n  .notification-calendar-btn:hover,\n  .mark-all-read-btn:hover {\n    background: rgba(94, 161, 216, 0.24) !important;\n  }\n\n  .notifications-container p,\n  .notifications-container span,\n  .notifications-container label,\n  .notifications-container small,\n  .notifications-container li {\n    color: #cbd5e1 !important;\n  }\n}\n\n.notification-items {\n  display: flex;\n  flex-direction: column;\n}\n\n// Individual notification item\n.notification-item {\n  display: flex;\n  align-items: flex-start;\n  padding: 12px 24px;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  position: relative;\n  gap: 12px;\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n\n  :host-context(body.theme-dark) & {\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.06);\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 12px 24px;\n    gap: 12px;\n  }\n\n  // ── Unread state ──────────────────────────────────────────────────────\n  &.unread {\n    // Light mode: soft blue wash\n    background-color: rgba(6, 95, 212, 0.07);\n\n    // Left accent stripe\n    &::before {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      top: 0;\n      bottom: 0;\n      width: 3px;\n      background-color: #065fd4;\n      border-radius: 0 2px 2px 0;\n    }\n\n    // Unread dot — top-right corner\n    &::after {\n      content: \"\";\n      position: absolute;\n      right: 16px;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 8px;\n      height: 8px;\n      border-radius: 50%;\n      background-color: #065fd4;\n      flex-shrink: 0;\n    }\n\n    // Bold message text so unread stands out from read\n    .notification-message {\n      font-weight: 600 !important;\n      color: #111 !important;\n    }\n\n    // Dark mode unread\n    :host-context(body.theme-dark) & {\n      background-color: rgba(59, 130, 246, 0.14);\n\n      &::before {\n        background-color: #60a5fa;\n      }\n\n      &::after {\n        background-color: #60a5fa;\n      }\n\n      .notification-message {\n        color: #f1f5f9 !important;\n      }\n    }\n  }\n}\n\n.notification-item.notification-item-disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n\n  &:hover {\n    background-color: transparent;\n  }\n}\n\n// Avatar\n.notification-item:not(.skeleton-notification-item) .notification-avatar {\n  cursor: pointer;\n}\n\n.notification-avatar {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  overflow: hidden;\n  position: relative;\n  align-self: flex-start; // Align with thumbnail at the top\n\n  @media (max-width: 768px) {\n    width: 40px;\n    height: 40px;\n    align-self: flex-start; // Ensure alignment with thumbnail\n  }\n\n  .avatar-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n\n  .avatar-placeholder {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #ffffff;\n    font-weight: 500;\n    font-size: 16px;\n    text-transform: uppercase;\n\n    @media (max-width: 768px) {\n      font-size: 16px;\n    }\n  }\n}\n\n// Content\n.notification-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  .notification-text {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .notification-message {\n    display: block;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: #333;\n    word-wrap: break-word;\n    /* Preserve API newlines: title / body / meta on separate lines */\n    white-space: pre-line;\n\n    :host-context(body.theme-dark) & {\n      color: #ffffff;\n    }\n\n    @media (max-width: 768px) {\n      font-size: 14px;\n    }\n\n    // Style links in message\n    a {\n      color: #065fd4;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .notification-time {\n    font-size: 12px;\n    color: #606060;\n    white-space: nowrap;\n    flex-shrink: 0;\n\n    :host-context(body.theme-dark) & {\n      color: #aaaaaa;\n    }\n\n    @media (max-width: 768px) {\n      font-size: 12px;\n    }\n  }\n\n  .notification-title-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 4px;\n\n    @media (min-width: 769px) {\n      // Desktop: title only, thumbnail is separate on right\n      flex-direction: column;\n      align-items: flex-start;\n    }\n  }\n\n  .notification-content-title {\n    font-size: 13px;\n    color: #606060;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    line-clamp: 1;\n    -webkit-box-orient: vertical;\n    flex: 1;\n    min-width: 0;\n\n    :host-context(body.theme-dark) & {\n      color: #aaaaaa;\n    }\n\n    @media (max-width: 768px) {\n      font-size: 13px;\n    }\n  }\n}\n\n// Thumbnail\n.notification-thumbnail {\n  flex-shrink: 0;\n  width: 80px;\n  height: 60px;\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: #f9f9f9;\n  position: relative;\n\n  :host-context(body.theme-dark) & {\n    background-color: #1f1f1f;\n  }\n\n  .thumbnail-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n  }\n}\n\n.notification-thumbnail--clickable {\n  cursor: pointer;\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .notifications-container {\n    padding: 0;\n  }\n}\n\n// Desktop optimizations\n@media (min-width: 1200px) {\n  .notifications-container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n\n  .notification-item {\n    padding: 14px 32px;\n  }\n}\n\n// Accessibility\n.notification-item {\n  &:focus {\n    outline: 2px solid #065fd4;\n    outline-offset: -2px;\n  }\n\n  &:focus:not(:focus-visible) {\n    outline: none;\n  }\n}\n\n// Smooth transitions\n* {\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.notification-calendar-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.notification-calendar-btn {\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid #065fd4;\n  background: #fff;\n  color: #065fd4;\n  cursor: pointer;\n\n  &:hover {\n    background: rgba(6, 95, 212, 0.08);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
